var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Silder',{attrs:{"list":_vm.list}}),_c('UserInfo'),_c('ActivityItem',{attrs:{"cname":_vm.$style.btsolid}}),_c('UserDynamic',{attrs:{"dynamicList":_vm.dynamicList}}),_c('UserDetailFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }